import { render } from "./MyInputForm.vue?vue&type=template&id=4457da6d&scoped=true"
import script from "./MyInputForm.vue?vue&type=script&lang=js"
export * from "./MyInputForm.vue?vue&type=script&lang=js"

import "./MyInputForm.vue?vue&type=style&index=0&id=4457da6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4457da6d"]])

export default __exports__